/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables = Types.Exact<{
  employeeKey: Types.Scalars['String']['input'];
}>;

export type CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery = {
  readonly __typename?: 'Query';
  readonly underwriterEmployees?: {
    readonly __typename?: 'UnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly jobFunction?: Types.JobFunction | null;
      readonly department?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phoneNumber1?: string | null;
      readonly phoneNumber2?: string | null;
      readonly faxNumber1?: string | null;
      readonly faxNumber2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly createdOn: string;
      readonly createdByUserName?: string | null;
      readonly modifiedOn: string;
      readonly modifiedByUserName?: string | null;
      readonly coveredAccountsCount: number;
      readonly userAccount?: {
        readonly __typename?: 'UserAccount';
        readonly isActive: boolean;
        readonly name?: string | null;
        readonly email?: string | null;
        readonly jobFunction?: Types.IdentityJobFunction | null;
      } | null;
      readonly salesCoverage: ReadonlyArray<{
        readonly __typename?: 'InvestorFirmRelationship';
        readonly firmId: string;
        readonly employeeId: string;
        readonly firmKey?: string | null;
        readonly firmName: string;
        readonly firmStatus: Types.RolodexRecordStatus;
        readonly location?: string | null;
        readonly relationshipType: Types.RelationshipType;
        readonly relationshipStatus: Types.RolodexRecordStatus;
        readonly lastUpdated: string;
      }>;
    }> | null;
  } | null;
};

export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['UUID']['input'];
  employeeKey: Types.Scalars['String']['input'];
}>;

export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery = {
  readonly __typename?: 'Query';
  readonly adminUnderwriterEmployees?: {
    readonly __typename?: 'AdminUnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly jobFunction?: Types.JobFunction | null;
      readonly department?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phoneNumber1?: string | null;
      readonly phoneNumber2?: string | null;
      readonly faxNumber1?: string | null;
      readonly faxNumber2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly createdOn: string;
      readonly createdByUserName?: string | null;
      readonly modifiedOn: string;
      readonly modifiedByUserName?: string | null;
      readonly coveredAccountsCount: number;
      readonly userAccount?: {
        readonly __typename?: 'UserAccount';
        readonly isActive: boolean;
        readonly name?: string | null;
        readonly email?: string | null;
        readonly jobFunction?: Types.IdentityJobFunction | null;
      } | null;
      readonly salesCoverage: ReadonlyArray<{
        readonly __typename?: 'InvestorFirmRelationship';
        readonly firmId: string;
        readonly employeeId: string;
        readonly firmKey?: string | null;
        readonly firmName: string;
        readonly firmStatus: Types.RolodexRecordStatus;
        readonly location?: string | null;
        readonly relationshipType: Types.RelationshipType;
        readonly relationshipStatus: Types.RolodexRecordStatus;
        readonly lastUpdated: string;
      }>;
    }> | null;
  } | null;
};

export type SalesCoverageUnderwriterEmployeeDetailFragment = {
  readonly __typename?: 'UnderwriterEmployee';
  readonly id: string;
  readonly employeeKey: string;
  readonly name?: string | null;
  readonly titles?: ReadonlyArray<string> | null;
  readonly jobFunction?: Types.JobFunction | null;
  readonly department?: string | null;
  readonly status: Types.RolodexRecordStatus;
  readonly email1?: string | null;
  readonly email2?: string | null;
  readonly phoneNumber1?: string | null;
  readonly phoneNumber2?: string | null;
  readonly faxNumber1?: string | null;
  readonly faxNumber2?: string | null;
  readonly address1?: string | null;
  readonly address2?: string | null;
  readonly createdOn: string;
  readonly createdByUserName?: string | null;
  readonly modifiedOn: string;
  readonly modifiedByUserName?: string | null;
  readonly coveredAccountsCount: number;
  readonly userAccount?: {
    readonly __typename?: 'UserAccount';
    readonly isActive: boolean;
    readonly name?: string | null;
    readonly email?: string | null;
    readonly jobFunction?: Types.IdentityJobFunction | null;
  } | null;
  readonly salesCoverage: ReadonlyArray<{
    readonly __typename?: 'InvestorFirmRelationship';
    readonly firmId: string;
    readonly employeeId: string;
    readonly firmKey?: string | null;
    readonly firmName: string;
    readonly firmStatus: Types.RolodexRecordStatus;
    readonly location?: string | null;
    readonly relationshipType: Types.RelationshipType;
    readonly relationshipStatus: Types.RolodexRecordStatus;
    readonly lastUpdated: string;
  }>;
};

export type SalesCoverage_UpdateUnderwriterEmployeeStatusMutationVariables = Types.Exact<{
  input: Types.UpdateUnderwriterEmployeeInput;
}>;

export type SalesCoverage_UpdateUnderwriterEmployeeStatusMutation = {
  readonly __typename?: 'Mutation';
  readonly updateUnderwriterEmployee?: {
    readonly __typename?: 'UpdateUnderwriterEmployeePayload';
    readonly underwriterEmployee?: {
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly status: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export type SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationVariables = Types.Exact<{
  input: Types.AdminUpdateUnderwriterEmployeeInput;
}>;

export type SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation = {
  readonly __typename?: 'Mutation';
  readonly adminUpdateUnderwriterEmployee?: {
    readonly __typename?: 'AdminUpdateUnderwriterEmployeePayload';
    readonly underwriterEmployee?: {
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly status: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export type UpdateUnderwriterEmployeeFragment = {
  readonly __typename?: 'UnderwriterEmployee';
  readonly id: string;
  readonly employeeKey: string;
  readonly name?: string | null;
  readonly titles?: ReadonlyArray<string> | null;
  readonly jobFunction?: Types.JobFunction | null;
  readonly department?: string | null;
  readonly email1?: string | null;
  readonly email2?: string | null;
  readonly phoneNumber1?: string | null;
  readonly phoneNumber2?: string | null;
  readonly faxNumber1?: string | null;
  readonly faxNumber2?: string | null;
  readonly address1?: string | null;
  readonly address2?: string | null;
};

export type SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationVariables = Types.Exact<{
  input: Types.UpdateUnderwriterEmployeeInput;
}>;

export type SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation = {
  readonly __typename?: 'Mutation';
  readonly updateUnderwriterEmployee?: {
    readonly __typename?: 'UpdateUnderwriterEmployeePayload';
    readonly underwriterEmployee?: {
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly jobFunction?: Types.JobFunction | null;
      readonly department?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phoneNumber1?: string | null;
      readonly phoneNumber2?: string | null;
      readonly faxNumber1?: string | null;
      readonly faxNumber2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
    } | null;
  } | null;
};

export type SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationVariables = Types.Exact<{
  input: Types.AdminUpdateUnderwriterEmployeeInput;
}>;

export type SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation = {
  readonly __typename?: 'Mutation';
  readonly adminUpdateUnderwriterEmployee?: {
    readonly __typename?: 'AdminUpdateUnderwriterEmployeePayload';
    readonly underwriterEmployee?: {
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly jobFunction?: Types.JobFunction | null;
      readonly department?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phoneNumber1?: string | null;
      readonly phoneNumber2?: string | null;
      readonly faxNumber1?: string | null;
      readonly faxNumber2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
    } | null;
  } | null;
};

export type SalesCoverage_CreateUnderwriterEmployeeMutationVariables = Types.Exact<{
  input: Types.CreateUnderwriterEmployeeInput;
}>;

export type SalesCoverage_CreateUnderwriterEmployeeMutation = {
  readonly __typename?: 'Mutation';
  readonly createUnderwriterEmployee?: {
    readonly __typename?: 'CreateUnderwriterEmployeePayload';
    readonly underwriterEmployee?: {
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly jobFunction?: Types.JobFunction | null;
      readonly department?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phoneNumber1?: string | null;
      readonly phoneNumber2?: string | null;
      readonly faxNumber1?: string | null;
      readonly faxNumber2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
    } | null;
  } | null;
};

export type SalesCoverage_AdminCreateUnderwriterEmployeeMutationVariables = Types.Exact<{
  input: Types.AdminCreateUnderwriterEmployeeInput;
}>;

export type SalesCoverage_AdminCreateUnderwriterEmployeeMutation = {
  readonly __typename?: 'Mutation';
  readonly adminCreateUnderwriterEmployee?: {
    readonly __typename?: 'AdminCreateUnderwriterEmployeePayload';
    readonly underwriterEmployee?: {
      readonly __typename?: 'UnderwriterEmployee';
      readonly id: string;
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly jobFunction?: Types.JobFunction | null;
      readonly department?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phoneNumber1?: string | null;
      readonly phoneNumber2?: string | null;
      readonly faxNumber1?: string | null;
      readonly faxNumber2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
    } | null;
  } | null;
};

export const SalesCoverageUnderwriterEmployeeDetailFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeDetail' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coveredAccountsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const UpdateUnderwriterEmployeeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CrmManagement_SalesCoverage_UnderwriterEmployeeDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_SalesCoverage_UnderwriterEmployeeDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employeeKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'underwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'employeeKey' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'employeeKey' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeDetail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeDetail' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coveredAccountsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery__
 *
 * To run a query within a React component, call `useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery({
 *   variables: {
 *      employeeKey: // value for 'employeeKey'
 *   },
 * });
 */
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
  > &
    (
      | {
          variables: CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeeDetailDocument, options);
}
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeeDetailDocument, options);
}
// @ts-ignore
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
  CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
>;
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
        CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery | undefined,
  CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
>;
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
        CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeeDetailDocument, options);
}
export type CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery
>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeDetailLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailLazyQuery
>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeDetailSuspenseQueryHookResult =
  ReturnType<typeof useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailSuspenseQuery>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryResult = Apollo.QueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
  CrmManagement_SalesCoverage_UnderwriterEmployeeDetailQueryVariables
>;
export const CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employeeKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUnderwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'employeeKey' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'employeeKey' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeDetail' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeDetail' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coveredAccountsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesCoverage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery__
 *
 * To run a query within a React component, call `useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      employeeKey: // value for 'employeeKey'
 *   },
 * });
 */
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
  > &
    (
      | {
          variables: CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailDocument, options);
}
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailDocument, options);
}
// @ts-ignore
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
>;
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery | undefined,
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
>;
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailDocument, options);
}
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery
>;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailLazyQueryHookResult =
  ReturnType<typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailLazyQuery>;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailSuspenseQueryHookResult =
  ReturnType<typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailSuspenseQuery>;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryResult =
  Apollo.QueryResult<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQueryVariables
  >;
export const SalesCoverage_UpdateUnderwriterEmployeeStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SalesCoverage_UpdateUnderwriterEmployeeStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUnderwriterEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUnderwriterEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'underwriterEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SalesCoverage_UpdateUnderwriterEmployeeStatusMutationFn = Apollo.MutationFunction<
  SalesCoverage_UpdateUnderwriterEmployeeStatusMutation,
  SalesCoverage_UpdateUnderwriterEmployeeStatusMutationVariables
>;

/**
 * __useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation__
 *
 * To run a mutation, you first call `useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesCoverageUpdateUnderwriterEmployeeStatusMutation, { data, loading, error }] = useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SalesCoverage_UpdateUnderwriterEmployeeStatusMutation,
    SalesCoverage_UpdateUnderwriterEmployeeStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SalesCoverage_UpdateUnderwriterEmployeeStatusMutation,
    SalesCoverage_UpdateUnderwriterEmployeeStatusMutationVariables
  >(SalesCoverage_UpdateUnderwriterEmployeeStatusDocument, options);
}
export type SalesCoverage_UpdateUnderwriterEmployeeStatusMutationHookResult = ReturnType<
  typeof useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation
>;
export type SalesCoverage_UpdateUnderwriterEmployeeStatusMutationResult =
  Apollo.MutationResult<SalesCoverage_UpdateUnderwriterEmployeeStatusMutation>;
export type SalesCoverage_UpdateUnderwriterEmployeeStatusMutationOptions =
  Apollo.BaseMutationOptions<
    SalesCoverage_UpdateUnderwriterEmployeeStatusMutation,
    SalesCoverage_UpdateUnderwriterEmployeeStatusMutationVariables
  >;
export const SalesCoverage_AdminUpdateUnderwriterEmployeeStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SalesCoverage_AdminUpdateUnderwriterEmployeeStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminUpdateUnderwriterEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUpdateUnderwriterEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'underwriterEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationFn = Apollo.MutationFunction<
  SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation,
  SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationVariables
>;

/**
 * __useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation__
 *
 * To run a mutation, you first call `useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesCoverageAdminUpdateUnderwriterEmployeeStatusMutation, { data, loading, error }] = useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation,
    SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation,
    SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationVariables
  >(SalesCoverage_AdminUpdateUnderwriterEmployeeStatusDocument, options);
}
export type SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationHookResult = ReturnType<
  typeof useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation
>;
export type SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationResult =
  Apollo.MutationResult<SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation>;
export type SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationOptions =
  Apollo.BaseMutationOptions<
    SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation,
    SalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutationVariables
  >;
export const SalesCoverage_UpdateUnderwriterEmployeeUserDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SalesCoverage_UpdateUnderwriterEmployeeUserDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateUnderwriterEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUnderwriterEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'underwriterEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationFn = Apollo.MutationFunction<
  SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation,
  SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationVariables
>;

/**
 * __useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation__
 *
 * To run a mutation, you first call `useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesCoverageUpdateUnderwriterEmployeeUserDetailMutation, { data, loading, error }] = useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation,
    SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation,
    SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationVariables
  >(SalesCoverage_UpdateUnderwriterEmployeeUserDetailDocument, options);
}
export type SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationHookResult = ReturnType<
  typeof useSalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation
>;
export type SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationResult =
  Apollo.MutationResult<SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation>;
export type SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationOptions =
  Apollo.BaseMutationOptions<
    SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutation,
    SalesCoverage_UpdateUnderwriterEmployeeUserDetailMutationVariables
  >;
export const SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminUpdateUnderwriterEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUpdateUnderwriterEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'underwriterEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationFn =
  Apollo.MutationFunction<
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation,
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationVariables
  >;

/**
 * __useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation__
 *
 * To run a mutation, you first call `useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesCoverageAdminUpdateUnderwriterEmployeeUserDetailMutation, { data, loading, error }] = useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation,
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation,
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationVariables
  >(SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailDocument, options);
}
export type SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationHookResult = ReturnType<
  typeof useSalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation
>;
export type SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationResult =
  Apollo.MutationResult<SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation>;
export type SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationOptions =
  Apollo.BaseMutationOptions<
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutation,
    SalesCoverage_AdminUpdateUnderwriterEmployeeUserDetailMutationVariables
  >;
export const SalesCoverage_CreateUnderwriterEmployeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SalesCoverage_CreateUnderwriterEmployee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateUnderwriterEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUnderwriterEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'underwriterEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SalesCoverage_CreateUnderwriterEmployeeMutationFn = Apollo.MutationFunction<
  SalesCoverage_CreateUnderwriterEmployeeMutation,
  SalesCoverage_CreateUnderwriterEmployeeMutationVariables
>;

/**
 * __useSalesCoverage_CreateUnderwriterEmployeeMutation__
 *
 * To run a mutation, you first call `useSalesCoverage_CreateUnderwriterEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesCoverage_CreateUnderwriterEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesCoverageCreateUnderwriterEmployeeMutation, { data, loading, error }] = useSalesCoverage_CreateUnderwriterEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesCoverage_CreateUnderwriterEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SalesCoverage_CreateUnderwriterEmployeeMutation,
    SalesCoverage_CreateUnderwriterEmployeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SalesCoverage_CreateUnderwriterEmployeeMutation,
    SalesCoverage_CreateUnderwriterEmployeeMutationVariables
  >(SalesCoverage_CreateUnderwriterEmployeeDocument, options);
}
export type SalesCoverage_CreateUnderwriterEmployeeMutationHookResult = ReturnType<
  typeof useSalesCoverage_CreateUnderwriterEmployeeMutation
>;
export type SalesCoverage_CreateUnderwriterEmployeeMutationResult =
  Apollo.MutationResult<SalesCoverage_CreateUnderwriterEmployeeMutation>;
export type SalesCoverage_CreateUnderwriterEmployeeMutationOptions = Apollo.BaseMutationOptions<
  SalesCoverage_CreateUnderwriterEmployeeMutation,
  SalesCoverage_CreateUnderwriterEmployeeMutationVariables
>;
export const SalesCoverage_AdminCreateUnderwriterEmployeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SalesCoverage_AdminCreateUnderwriterEmployee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminCreateUnderwriterEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminCreateUnderwriterEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'underwriterEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateUnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jobFunction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'faxNumber2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SalesCoverage_AdminCreateUnderwriterEmployeeMutationFn = Apollo.MutationFunction<
  SalesCoverage_AdminCreateUnderwriterEmployeeMutation,
  SalesCoverage_AdminCreateUnderwriterEmployeeMutationVariables
>;

/**
 * __useSalesCoverage_AdminCreateUnderwriterEmployeeMutation__
 *
 * To run a mutation, you first call `useSalesCoverage_AdminCreateUnderwriterEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesCoverage_AdminCreateUnderwriterEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesCoverageAdminCreateUnderwriterEmployeeMutation, { data, loading, error }] = useSalesCoverage_AdminCreateUnderwriterEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesCoverage_AdminCreateUnderwriterEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SalesCoverage_AdminCreateUnderwriterEmployeeMutation,
    SalesCoverage_AdminCreateUnderwriterEmployeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SalesCoverage_AdminCreateUnderwriterEmployeeMutation,
    SalesCoverage_AdminCreateUnderwriterEmployeeMutationVariables
  >(SalesCoverage_AdminCreateUnderwriterEmployeeDocument, options);
}
export type SalesCoverage_AdminCreateUnderwriterEmployeeMutationHookResult = ReturnType<
  typeof useSalesCoverage_AdminCreateUnderwriterEmployeeMutation
>;
export type SalesCoverage_AdminCreateUnderwriterEmployeeMutationResult =
  Apollo.MutationResult<SalesCoverage_AdminCreateUnderwriterEmployeeMutation>;
export type SalesCoverage_AdminCreateUnderwriterEmployeeMutationOptions =
  Apollo.BaseMutationOptions<
    SalesCoverage_AdminCreateUnderwriterEmployeeMutation,
    SalesCoverage_AdminCreateUnderwriterEmployeeMutationVariables
  >;
